import { makeRequest } from "../http-common";

const AttachmentDataService = {
  async getById(id) {
    return makeRequest("get", `/attachment/${id}`);
  },

  async getByRef(ref) {
    return makeRequest("get", `/attachment/${ref}/related`);
  },

  async create(data) {
    return makeRequest("post", "/attachment", data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

export default AttachmentDataService;